/* eslint-disable react/no-did-update-set-state */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import SingleDatePickerActual from './SingleDatePickerActual';

export default class SingleDatePicker extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        ariaLabel: PropTypes.string
    };

    static defaultProps = {
        id: 'date',
        ariaLabel: 'Date'
    };

    state = {
        dateError: null
    }

    componentDidUpdate() {
        // Validation error here is for isRequired only and it's only
        // a moment in time. So we reset it once the component updates and
        // let the internal component takeover the validation state.
        if (this.state.dateError) {
            this.setState({
                dateError: null
            });
        }
    }

    validate = () => {
        const {
            date,
            isOutsideRange,
            isDayBlocked,
            id,
            ariaLabel,
            required,
            isRequired
        } = this.props;

        const validationState = {
            isInvalid: false,
            errorText: null,
            id
        };

        if (isRequired || required) {
            const dateError = date ? null : 'is required';

            if (dateError) {
                this.setState({ dateError });

                validationState.isInvalid = true;
                validationState.errorText = `${ariaLabel} is required.`;
                return validationState;
            }
        }

        if (date && moment.isMoment(date)) {
            let isDateInvalid = false;

            if (isOutsideRange) {
                isDateInvalid = isOutsideRange(date);
            }
            if (!isDateInvalid && isDayBlocked) {
                isDateInvalid = isDayBlocked(date);
            }

            if (isDateInvalid) {
                validationState.isInvalid = true;
                validationState.errorText = `${ariaLabel} is not available.`;
                return validationState;
            }

            // It's valid
            this.setState({
                dateError: null
            });
        }

        return validationState;
    }

    render() {
        const { dateError } = this.state;
        const { isRequired, required, ...rest } = this.props;

        return (
            <SingleDatePickerActual
                {...rest}
                required={isRequired || required}
                dateError={dateError} />
        );
    }
}